function findMatchingStores(zipCode) {
    zipCode = parseInt(zipCode);
    const matchingStores = [];
    inHomeLocations.forEach((location) => {
      if (location.zipcodes.includes(zipCode)) {
        matchingStores.push({
          showroom: location.showroom,
          nsID: location.nsID
        });
      }
    });
    return matchingStores;
  }
  
  function findMatchingInStores(zipCode) {
    zipCode = parseInt(zipCode);
    const matchingInStores = [];
    inHomeLocations.forEach((location) => {
      if (location.zipcodes150.includes(zipCode)) {
        matchingInStores.push({
          showroom: location.showroom,
          nsID: location.nsID
        });
      }
    });
    return matchingInStores;
  }
  